import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "theme-uipresets"
    }}>{`@theme-ui/presets`}</h1>
    <p>{`Theme UI includes an optional presets package that can be used as examples or as a starting point for extending your own themes.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i @theme-ui/presets
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// example theme
import { funk } from '@theme-ui/presets'

export default {
  ...funk,
  styles: {
    ...funk.styles,
  },
}
`}</code></pre>
    <p>{`To view an example of the built-in presets, see the `}<a parentName="p" {...{
        "href": "https://theme-ui.com/demo"
      }}>{`Demo`}</a>{`.`}</p>
    <p>{`Currently, the following presets are available for use:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://theme-ui.com/presets/base"
        }}><inlineCode parentName="a">{`base`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://theme-ui.com/presets/system"
        }}><inlineCode parentName="a">{`system`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://theme-ui.com/presets/funk"
        }}><inlineCode parentName="a">{`funk`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://theme-ui.com/presets/future"
        }}><inlineCode parentName="a">{`future`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://theme-ui.com/presets/roboto"
        }}><inlineCode parentName="a">{`roboto`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://theme-ui.com/presets/dark"
        }}><inlineCode parentName="a">{`dark`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://theme-ui.com/presets/deep"
        }}><inlineCode parentName="a">{`deep`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://theme-ui.com/presets/swiss"
        }}><inlineCode parentName="a">{`swiss`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://theme-ui.com/presets/tosh"
        }}><inlineCode parentName="a">{`tosh`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://theme-ui.com/presets/bootstrap"
        }}><inlineCode parentName="a">{`bootstrap`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://theme-ui.com/presets/bulma"
        }}><inlineCode parentName="a">{`bulma`}</inlineCode></a>{` (WIP)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://theme-ui.com/presets/tailwind"
        }}><inlineCode parentName="a">{`tailwind`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://theme-ui.com/presets/sketchy"
        }}><inlineCode parentName="a">{`sketchy`}</inlineCode></a>{`, `}<a parentName="li" {...{
          "href": "https://themeui-sketchy.netlify.app/"
        }}>{`Demo website`}</a></li>
    </ul>
    <h2 {...{
      "id": "contributing"
    }}>{`Contributing`}</h2>
    <p>{`We'd love to have more presets added to the Theme UI project.
If you'd like to add a new preset or improve upon the existing ones, please open an `}<a parentName="p" {...{
        "href": "https://github.com/system-ui/theme-ui/issues"
      }}>{`issue`}</a>{` or `}<a parentName="p" {...{
        "href": "https://github.com/system-ui/theme-ui/pulls"
      }}>{`pull request`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      